export type OrderMultiSelectKey = "brokerIds" | "countryIds" | "payMethodIds" | "responsibleIds";
export type OrderFilterKey = OrderMultiSelectKey;

export interface IExtendedOrderFilters {
    brokerIds?: number[];
    countryIds?: number[];
    payMethodIds?: number[];
    responsibleIds?: number[];
}

const CRM_FILTERS: OrderFilterKey[] = ["brokerIds", "countryIds", "payMethodIds", "responsibleIds"];

export const getCrmFilters = (): OrderFilterKey[] => CRM_FILTERS;